import apiFetch from '../apiFetch'

export default function (userProcessingAgencyId, token) {
  return apiFetch({ endPoint: 'DeleteUserProcessingAgency/' + userProcessingAgencyId, method: 'DELETE', body: null, token: token })
}
